import h from '../utils/htm';
import http from '../utils/http';
import { googleMapsKey, mapStyles, rootURL } from '../constants';
import MarkerWithLabel from '@googlemaps/markerwithlabel';
import domWrap from '../utils/domWrap';
import {titleCase} from '../utils/titleCase';
import {dealerExtendAddress} from '../utils/dealerExtendAddress';
import getDistance from '../utils/getDistance';
import strDefaults from '../utils/strDefaults';
import getParameterByName from '../utils/getParameterByName';
import dateTimeService from '../utils/dateTimeService';
import Mustache from 'mustache';


const	filtersFromUrl = strDefaults(getParameterByName('f')),
		filters = [
			{ key: 'Sales', label: 'Sales', description: 'Location provides truck sales', fnFilter: filterContains },
			{ key: 'Parts', label: 'Parts', description: 'Location provides parts sales and warranty', fnFilter: filterContains },
			{ key: 'Service', label: 'Service', description: 'Location provides truck service and warranty', fnFilter: filterContains },
			{
				key: 'EliteSupport',
				label: 'Elite Support',
				description: 'Location is Elite Certified and provides rapid diagnosis, mission critical parts inventory and meets several high operational performance standards. <a href="/service/elite-support/">View more details about Elite Support locations</a>',
				fnFilter: (property, location) => { return location.eliteSupport === true; }
			},
            {
                key: 'isECertified',
                label: 'eCertified',
                description: 'Location is eCertified and has met required criteria to seamlessly support customer\'s Battery Electric Vehicle (BEV) needs across all departments within the dealership.',
                fnFilter: (property, location) => { return location.isECertified === true; }
            },
			{
				key: 'isExpressPoint',
				label: 'ExpressPoint',
				description: 'Location provides ExpressPoint services; available at select Love\'s and Speedco locations. <a href="/service/expresspoint/">View more details about ExpressPoint</a>',
				fnFilter: (property, location) => { return location.isExpressPoint === true; }
			},
			{
				key: 'IsBodyShop',
				label: 'Body Shop',
				description: 'Location provides body shop service',
				fnFilter: (property, location) => { return location.isBodyShop === true; }
			}
		].map(function (item) {
			return {
				key: item.key,
				label: item.label,
				html: h('div class="filter" data-filter="'+item.key+'"', h('span',item.label)) + '',
				description: h('div',h('label class="tw-filter-label"', item.label)('div',item.description)) + '',
				selected: filtersFromUrl[item.key] || false,
				fnFilter: item.fnFilter
			};
		}),
		departmentsList = [
			'Sales',
			'Parts',
			'Service'
		],
		weekDays = [
			'Sunday',
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday'
		],
		currentDay = (new Date()).getDay(),
		dayOfWeek = weekDays.find((item, index) => {
			return index === currentDay;
		});

export default async container => { // 'comp-dealers'
	const 	{default: _} = await import('lodash'),
			{default: MapsLoader} = await import('load-google-maps-api'),
			Maps = await MapsLoader({
				v: '3.30',
				key: googleMapsKey,
				libraries: ['places']
			}),
		currentDateTime = new Date(),
		utcMinutes = dateTimeService(currentDateTime).utcMinutes(),
		dealersElement = domWrap(container),
		listContainer = dealersElement.querySelector('[list]'),
		tabs = [];
	
	let accuracy = 10,
		geo = new Maps.Geocoder(),
		searchApi = container.hasAttribute('searchApi') ? container.getAttribute('searchApi') : rootURL +'/umbraco/backoffice/dealers/geo-search',
		currentLocation = {},
		lastZ = 100,
		directionsService = new Maps.DirectionsService(),
		directionsDisplay = new Maps.DirectionsRenderer(),
		pendingCall = getListings().catch(()=>{}),
		locations = [],
		map,
		dataCache = {},
		getOptions = function() {
			return {
				zoom: 9,
				mapTypeControl: false,
				streetViewControl: false,
				scrollwheel: false,
				draggable: true,
				styles: mapStyles
			};
		};

	dealersElement.querySelector('.filters-container').innerHTML = 
		h('header',h('button class="filters-toggle"','Filter by Services')('button class="filters-info-toggle"',''))
		('div class="filters-info tw-hidden"',filters.reduce(function(str,cur){ return str + cur.description},''))
		('div class="filters"',filters.reduce(function(str,cur){ return str + cur.html},'')).toString();

	filters.forEach(cur => {
		if(cur.selected){
			dealersElement.querySelector('.filters > .filter[data-filter="'+cur.key+'"]')?.classList.add('selected');
		}
	});

	dealersElement.on('click', '.filters-info-toggle', function () {
		dealersElement.querySelector('.filters-info').classList.toggle('expanded');
		this.classList.toggle('active');
	})
		.on('click', '.filters-toggle', function () {
			if (window.innerWidth < 960) {
				dealersElement.querySelector('.filters').classList.toggle('expanded');
				this.classList.toggle('active');
			}
		})
		.on('click', '.filters > .filter', function () {
			const key = this.getAttribute('data-filter'),
				item = filters.find(itm => itm.key === key);

			if (this.classList.contains('disabled')) return false;

			if (item.selected) {
				item.selected = false;
				this.classList.remove('selected');
			}
			else {
				item.selected = true;
				this.classList.add('selected');
			}
			cleanupLocations().then(() => {
				drawLocations({ container: dealersElement.querySelector('[list]'), locations, map });
				history.replaceState({}, document.title, window.location.origin + window.location.pathname + '?f=' + filters.filter(item => item.selected).map(item => item.key).join(','));
			});
		})
		.on('click', 'button[search]', search)
		.on('keypress', 'input[name="location"]', function (e) {
			if (e.which == 13) {
				search(e);
			}
		})
		.on('click', 'button[route]', route)
		.on('keypress', 'input[name="start"], input[name="end"]', function (e) {
			if (e.which == 13) {
				route(e);
			}
		})
		.on('click', 'button[geo]', function () {
			fillGeo(this.parentNode.querySelector('input[type="text"]')).then(() => {
				domWrap(this.closest('[tab]').querySelector('button[search],button[route]')).trigger('click');
			});
		})
		.on('click', 'div[close]', function () {
			[...document.querySelectorAll('[selected]')].forEach(item => item.innerHTML = '');
		})
		.on('click', '.expandible .default', function () {
			this.classList.toggle('detail')
			this.closest('.expandible').querySelector('.extended').classList.toggle('expanded');
		})
		.on('click', 'button.details', function () {
			this.classList.toggle('detail');
			this.closest('.location').querySelector('div.details').classList.toggle('expanded');
		});

	[...dealersElement.querySelectorAll('aside > button')].forEach(button => button.addEventListener('click',() => {
		const center = map.getCenter();
		dealersElement.classList.toggle('fullscreen');
		map.setZoom(getOptions().zoom);
		document.body.classList.toggle('takeover-active');
		Maps.event.trigger(map,'resize');
		map.setCenter(center);
	}));	

	[...dealersElement.querySelectorAll('button[data-toggle]')].forEach(button => {
		const tab = {
			id: button.getAttribute('data-toggle')
		}
		tabs.push(tab);
		button.onclick = () => {			
			for (let i = 0, l = tabs.length; i < l; i++) {				
				const element = document.getElementById(tabs[i].id);
				element.style.display = tab.id === tabs[i].id
					? 'block'
					: 'none';
			}
		};
	});
	
	fillGeo(dealersElement.querySelector('input[name="location"],input[name="start"]'))
		.then(() => domWrap(dealersElement.querySelector('button[search]')).trigger('click'))
		.catch(()=>{});

	[...dealersElement.querySelectorAll('input[name="location"],input[name="start"],input[name="end"]')].forEach(element => {
		new Maps.places.Autocomplete(element, { types: ['geocode'] });
	});

	(()=>{
		let trigger = 36,
			fixed = false,
			fixedBottom = false,
			map = domWrap(dealersElement.querySelector('.map-spacer')),
			mapHolder = domWrap(map.closest('aside')),
			filters = dealersElement.querySelector('.filters-container');

		function scrollCheck(){
			var scrollTop = window.scrollY,
				mapTop = map.offset().top,
				makeFixed = scrollTop + trigger > mapTop,
				makeFixedBottom = mapHolder.offset().top + mapHolder.offsetHeight - window.innerHeight < scrollTop ;
			if(makeFixed !== fixed){
				fixed = makeFixed;
				map.classList.toggle('map-fixed',fixed);
				filters.classList.toggle('map-fixed',fixed);
			}
			if(makeFixedBottom !== fixedBottom){
				fixedBottom = makeFixedBottom;
				map.classList.toggle('map-fixed-bottom',fixedBottom);
				filters.classList.toggle('map-fixed-bottom',fixedBottom);
			}
		}

		window.addEventListener('scroll',scrollCheck);
		window.addEventListener('resize',scrollCheck);
		scrollCheck();
	})();

	function locationInit(item, index) {
		item.marker = makeMarker(item);
		if (item.marker.getMap() !== map) {
			item.marker.setMap(map);
		}
		item.distance = Math.round
			(getDistance(item.latitude, item.longitude, currentLocation.lat(), currentLocation.lng()));
		item.index = index;
		return item;
	}

	function search(e) {		
		var tab = e.target.closest('[tab]'),
			addr = (dealersElement.querySelector('input[name="location"]')?.value || '').trim();
		if (addr.length > 1) {
			loading(listContainer);
			geo.geocode({ 'address': addr }, (results, status) => {
				if (status === Maps.GeocoderStatus.OK) {
					currentLocation = results[0].geometry.location;
					map = new Maps.Map(dealersElement.querySelector("[map]"), Object.assign({
						center: results[0].geometry.location
					}, getOptions()));					
					Maps.event.addListener(map, 'bounds_changed', _.throttle(() => {
						var bounds = map.getBounds(),
							ne = bounds.getNorthEast(),
							sw = bounds.getSouthWest();

						pendingCall = getListings({
							north: ne.lat(),
							south: sw.lat(),
							east: ne.lng(),
							west: sw.lng()
						}, dataCache, searchApi).then(data => {
							cleanupLocations(locations);
							locations = data.map((item, index) => locationInit(item, index));
							drawLocations({container: dealersElement.querySelector('[list]'), locations, map});
						}).catch((ex) => { console.error(ex); });
					}, 500, { 'leading': false }));
				} else {
					console.info("Geocode was not successful for the following reason: " + status);
					inputAlert(tab, 'Sorry, we could not find that location.');
				}
			});
		} else {
			inputAlert(tab, 'Please enter a location to search.');
		}
	}

	function route(e) {
		var tab = e.target.closest('[tab]'),
			addrFrom = (dealersElement.querySelector('input[name="start"]')?.value || '').trim(),
			addrTo = (dealersElement.querySelector('input[name="end"]')?.value || '').trim();
		if (addrFrom.length > 1 && addrTo.length > 1) {
			loading(listContainer);
			directionsService.route({
				origin: addrFrom,
				destination: addrTo,
				travelMode: Maps.TravelMode.DRIVING
			}, function(result, status) {
				var polyCoords;
				if (status == Maps.DirectionsStatus.OK) {
					polyCoords = getPolyCoords(result.routes[0].legs, (accuracy / 2) * 28);
					currentLocation = result.routes[0].legs[0].start_location;

					map = new Maps.Map(dealersElement.querySelector("[map]"), getOptions());
					directionsDisplay.setMap(map);
					directionsDisplay.setOptions({ suppressMarkers: true });
					directionsDisplay.setDirections(result);
					Maps.event.addListener(map, 'bounds_changed', _.throttle(function(event) {
						var bounds = map.getBounds(),
							ne = bounds.getNorthEast(),
							sw = bounds.getSouthWest();

						pendingCall = getListings({
							north: ne.lat(),
							south: sw.lat(),
							east: ne.lng(),
							west: sw.lng()
						}, dataCache, searchApi).then(function(data) {
							cleanupLocations(locations);
							locations = data.filter(function(item) {
								return polyCoords.find(function(coord) {
									return getDistance(coord[0], coord[1], item.latitude, item.longitude) < accuracy;
								});
							}).map(locationInit);								
							drawLocations({container: dealersElement.querySelector('[list]'), locations, map});
						}).catch(()=>{});
					}, 500, { 'leading': false }));


				}
				else {
					console.info("Directions was not successful for the following reason: " + status);
					inputAlert(tab, 'Sorry, we could not find a route based on those locations.');
				}
			});
		} else {
			if (addrFrom.length < 2) {
				inputAlert(tab, 'Please enter a "From" location.');
			}
			if (addrTo.length < 2) {
				inputAlert(tab, 'Please enter a "To" location.');
			}
		}
	}

	function servicesLookup(departments) {
		const collection = {};

		for (let i = 0, l = departments.length; i < l; i++) {
			const key = _.kebabCase(departments[i].type);
			collection[key] = departments[i].type;
		}

		return collection;
	}

	function isOpen(location) {
		const isOpen = departmentsList.find(function (department) {
			const key = department.toLocaleLowerCase();
			const dep = location[key] ? location[key].fields[0] : false;
			const dayKey = dayOfWeek.toLocaleLowerCase();
			if (!dep
				|| dep.schedule[dayKey].status === 'Closed'
				|| (dep.schedule[dayKey].openHours.case && dep.schedule[dayKey].openHours.case === 'Closed'))
				return false;

			return dep.schedule[dayKey].openHours.case === 'AllDay'
				|| dep.schedule[dayKey].status === 'AllDay'
				|| (dep.schedule[dayKey].openHours.fields.length === 2
					&& dep.schedule[dayKey].openHours.fields[0] <= utcMinutes
					&& dep.schedule[dayKey].openHours.fields[1] >= utcMinutes);
		});

		return isOpen;
	}

	function getMapListings(listings, selectedFilters, map) {

		const mapListings = [];

		const sortedListings = listings
			.sort((x, y) => x.distance - y.distance);
		
		for (let i = 0; i < sortedListings.length; i++) {

			const location = sortedListings[i];
			const visibleIndex = i + 1;
			const { mapLink, htmlAddress } = dealerExtendAddress(location);

			location.marker.label.set('labelContent', visibleIndex);
			location.marker.label.labelDiv.textContent = visibleIndex;
			location.marker.setMap(map);

			const showFullAddress = htmlAddress.indexOf('<br') > -1; 

			const urlName = encodeURIComponent(location.name)
				.toLowerCase()
				.replaceAll('%20', '-')
				.replaceAll("'", '')
				.replaceAll('%27', '');

			const prepend = {
				dealerUrl: `/dealer/${location.code.toLowerCase() }/${urlName}/`,
				htmlAddress,
				isOpen: isOpen(location),
				mapLink,
				showDetails: !location.isInternational,
				showDirections: !location.isInternational,
				showDistance: !location.isInternational,
				showFullAddress,
				showHtmlAddress: !showFullAddress,
				visibleIndex
			}
			const copy = Object.assign(location, prepend);
			
			mapListings.push(copy);
		}
		
		return mapListings;
	}

	function populateHeader(count) {

		const listingHeader = container.querySelector('[data-target="[LISTING-HEADER]"]');

		if (listingHeader !== null) {
			let locationSummary = `${count} Location`;

			if (count > 1)
				locationSummary += 's';

			locationSummary += ' Found';

			listingHeader.innerHTML = locationSummary;
		}
	}

	function populateListings(listings, selectedFilters, map) {

		const template = container.querySelector('[data-target="[LISTINGS]"]');

		if (template !== null) {
			const mapListings = getMapListings(listings, selectedFilters, map);
			
			listContainer.innerHTML = Mustache.render(template.innerHTML, { listings: mapListings });			
		}
	}

	function drawLocations({ container, locations, map }) {

		// clear the map pins
		for (let i = 0, l = locations.length; i < l; i++)
			locations[i].marker.setMap(null);

		const selectedFilters = filters.filter((x) => x.selected);

		const availableFilters = locations.reduce((obj, location) => {
			filters.forEach((filter) => {
				if (filter.fnFilter(filter.key, location)) {
					obj[filter.key] = true;
				}
			});
			return obj;
		}, {});

		const filteredLocations = locations.filter((location) => {
				return !selectedFilters.find((filter) => {
					return !filter.fnFilter(filter.key, location);
				});
		});	

		const groupLabels = ['[HEADER]', 'Partner Locations'];
		
		[...container.querySelectorAll('.filters > .filter')]
			.forEach(btn => btn.classList.toggle('disabled', !availableFilters[btn.getAttribute('data-filter')]));
			
		populateHeader(filteredLocations.length);
		
		populateListings(filteredLocations, selectedFilters, map);

		[...container.querySelectorAll('a.view')].forEach(a => a.addEventListener('click', (e) => {
			if (gtag_report_conversion && typeof gtag_report_conversion === 'function')
				gtag_report_conversion();

			window.location.href = a.href;
		}));
	}

	function loading(el) {
		el.innerHTML = h('h3', 'Loading...');
	}

	function fillGeo(el) {
		const parent = el.parentNode;
		function cancel() {
			el.classList.remove('loading-location')
			el.removeEventListener('click', cancel);
		}
		if (parent.classList.contains('loading-location')) {
			return new Promise((resolve,reject) => reject());
		}
		return new Promise((resolve,reject) => {
			parent.classList.add('loading-location')
			parent.classList.remove('fallback')
			parent.addEventListener('click', cancel);

			navigator.geolocation.getCurrentPosition(position => {
				if (!parent.classList.contains('loading-location')) {
					return;
				}
				geo.geocode({ 'location': { lat: position.coords.latitude, lng: position.coords.longitude } }, function(results, status) {
					if (!parent.classList.contains('loading-location')) {
						return;
					}
					if (status === Maps.GeocoderStatus.OK) {
						if (results[0]) {
							el.value = results[0].formatted_address;
							resolve();
						} else {
							reject();
							console.info('No results found');
						}
					} else {
						reject();
						console.info('Geocoder failed due to: ' + status);
					}
					parent.classList.remove('fallback')
					parent.classList.remove('loading-location')
					parent.removeEventListener('click', cancel);
				});
			}, PosError => {
				console.log(PosError);
				//alert('There was an error loading your location. Please search by city, state or zip.');
				geoFallback(el).then(resolve).catch(reject);
				parent.classList.add('fallback')
				parent.removeEventListener('click', cancel);
			}, { enableHighAccuracy: true, maximumAge: 10000, timeout: navigator.userAgent.toLowerCase().indexOf("android") > -1 ? 15000 : 5000 });
				
		});
	}

	function geoFallback(el) {
		const parent = el.parentNode;
		return new Promise((resolve, reject) => {
			if (parent.classList.contains('loading-location') || el.value === '') {
				http('https://api.ipstack.com/check?access_key=7652d0f71a5071a6044703dc68df0d05&output=json&legacy=1').get().then(data => {
					if (data.city && data.region_code) {
						el.value = data.city + ', ' + data.region_code;
						resolve();
					}
					else {
						reject();
					}
					parent.classList.remove('loading-location');
				}).catch(() => {
					reject();
					parent.classList.remove('loading-location');
				});
			}	
		});
	}

	function makeMarker(item) {
		lastZ += 1;
		let markerOptions = {
			position: new Maps.LatLng(item.latitude, item.longitude),
			title: item.name,
			zIndex: lastZ,
			draggable: false,
			clickable: true,
			labelContent: '',
			labelAnchor: new Maps.Point(-15, -40),
			labelClass: 'marker-label', // the CSS class for the label
			labelInBackground: false,
			icon: {
				url: '/images/map-pin.png',
				size: new Maps.Size(42, 68),
				origin: new Maps.Point(0, 0),
				anchor: new Maps.Point(15, 49),
				scaledSize: new Maps.Size(30, 49)
			}
		};
		return new MarkerWithLabel(markerOptions);

	}

	function getListings(opt, dataCache, url) {	
		return 	new Promise((resolve,reject) => {
			if(!opt){
				reject();
				return;
			}
			const hash = hashCode(JSON.stringify(opt));
			if (dataCache[hash]) {
				resolve(dataCache[hash]);
			} else {
				http(url).get(opt).then(data => {					
					dataCache[hash] = data;
					resolve(data);
				}).catch(reject);
			}
		});
	}
}

function filterBoolean(property, location) {
	return location[property] && location[property] === true;
}

function filterContains(property, location) {
	property = property.toLowerCase();
	const index = location.departments.findIndex(x => x.name.toLowerCase() === property);
	return index > -1;
}

function cleanupLocations(locations = []) {
	return 	new Promise((resolve) => {
		Promise.all(
			locations.map(location => new Promise(resolve => setTimeout(() => {
				location.marker.setMap(null);
				resolve();
			}, 20)))
		)
		.then(resolve);
	});
}

function inputAlert(el, message) {
	var mess = domWrap(h('div class="input-alert"', message).Node);
	el.parentNode.insertBefore(mess, el.nextSibling);
	mess.classList.add('expanded');
	setTimeout(() => {
		mess.classList.remove('expanded');
		setTimeout(() => mess.remove(),300);
	}, message.split(' ').length * 300);
}

function getPolyCoords(legs, coordAccuracy) {
	var polyCoords = [],
		skippedCoords = 0;
	legs.forEach(function(leg) {
		leg.steps.forEach(function(step) {
			step.path.forEach(function(nextSegment) {
				if (skippedCoords < coordAccuracy) {
					skippedCoords += 1;
				}
				else {
					polyCoords.push([nextSegment.lat(), nextSegment.lng()]);
					skippedCoords = 0;
				}
			});
		});
	});
	return polyCoords;
}

function hashCode(code) {
	var hash = 0;
	if (code.length == 0) return hash;
	for (var i = 0; i < code.length; i++) {
		var char = code.charCodeAt(i);
		hash = ((hash << 5) - hash) + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash;
}

